import cc from "classcat"
import React from "react"
import { useFormContext } from "react-hook-form"

import styles from "./BudgetSummary.module.css"

import CurrencyInput from "~/common/CurrencyInput"

import { PRICING_MODELS, PricingModelSelection } from "~/GLOBALVARS"
import BudgetMethodSelector from "~/forms/ProjectBudgetForm/RoleBudget/BudgetMethodSelector"
import SelectPricingModel from "~/forms/ProjectForm/SelectPricingModel"

import { useProjectBudgetFormContext } from "../ProjectBudgetFormProvider"
import {
  ProjectBudgetFormData,
  projectBudgetValidationRules,
} from "../formTypes"

type Props = {
  currency: string
  allowBillingMethodEdit: boolean
}

const BudgetSummary = (props: Props) => {
  const { currency, allowBillingMethodEdit = true } = props

  const { watch, setValue } = useFormContext<ProjectBudgetFormData>()
  const formData = watch()
  const { showNonBillableView } = useProjectBudgetFormContext()

  const billingMethod = PRICING_MODELS.find(
    (pm) => pm.value === formData.pricingModel,
  )

  const invalid = !projectBudgetValidationRules.totalBudget.validate(
    formData.totalBudget,
  )

  const handleBillingMethodChange = (method: PricingModelSelection) => {
    setValue("pricingModel", method.value)
    if (method.value === "nb") {
      setValue("budgetMethod", "ROLE")
    }
  }

  const handleBudgetMethodChange = (method: string) => {
    setValue("budgetMethod", method as "ROLE" | "PHASE")
  }

  const handleTotalBudgetChange = (budget: number) => {
    setValue("totalBudget", budget)
  }

  return (
    <div className={styles.container}>
      <div className={styles.selectorContainer}>
        <div className={styles.selectorWrapper}>
          <div className={styles.label}>Pricing Model</div>
          <SelectPricingModel
            value={billingMethod}
            onChange={handleBillingMethodChange}
            height={40}
            fontSize={13}
            isDisabled={!allowBillingMethodEdit}
            dataTest="budget-pricing-model"
          />
        </div>
        {billingMethod.value !== "nb" && (
          <div className={styles.selectorWrapper}>
            <div className={styles.label}>Budget Method</div>
            <BudgetMethodSelector
              value={formData.budgetMethod}
              onChange={handleBudgetMethodChange}
            />
          </div>
        )}
      </div>
      {!showNonBillableView && (
        <div className={styles.budgetWrapper}>
          <div className={cc([styles.label, invalid && styles.invalidLabel])}>
            Project Budget {invalid && "is invalid"}
          </div>
          <CurrencyInput
            name="total-budget"
            dataTest="total-budget"
            style={{ textAlign: "right" }}
            value={formData.totalBudget}
            onChange={handleTotalBudgetChange}
            currency={currency}
            height={40}
            fontSize={13}
            stepSize={1000}
            error={invalid}
            integer={true}
            selectAllOnFocus
          />
        </div>
      )}
    </div>
  )
}

export default BudgetSummary
